export default "/images/vendor/flag-icons/flags/4x3/ws.svg?314e33c2a444698f4bce5c7346cae980";